<fieldset class="grid" aria-label="Einstellungen zur Registerabschrift" data-test-id="aufgabe-abschrift-root">
	<div class="row">
		<div class="column">
			<mat-form-field appearance="outline">
				<mat-label>beglaubigte</mat-label>
				<input
					min="1"
					matInput
					type="number"
					[formControl]="bodyControls.beglaubigte"
					data-test-id="beglaubigte-input" />
				@if (bodyControls.beglaubigte.invalid) {
					<mat-error data-test-id="invalid-beglaubigte-message">Eingabe muss eine ganze Zahl sein</mat-error>
				}
			</mat-form-field>
		</div>
		<div class="column">
			<mat-form-field appearance="outline">
				<mat-label>einfache</mat-label>
				<input
					min="1"
					matInput
					type="number"
					[formControl]="bodyControls.einfache"
					data-test-id="einfache-input" />
				@if (bodyControls.einfache.invalid) {
					<mat-error data-test-id="invalid-einfache-message">Eingabe muss eine ganze Zahl sein</mat-error>
				}
			</mat-form-field>
		</div>
	</div>
	<schir-int-client-notiz-in-aufgabe-editor class="row note" [aufgabenTyp]="AufgabenTyp.REGISTERABSCHRIFT" />
</fieldset>
